import { useEffect } from "react";
import { ListSkeleton } from "../../skeletons/List";
import { useState } from "react";
import { Button, Container, Typography, Box, Tab, Tabs, styled, TextField, Modal, Select, FormControl, InputLabel } from "@mui/material";
import FloatingActionButtons from "../../components/Fab";
import { useDashboardDrawer } from "../../providers/consumers/useDashboardDrawer";
import { useBuilder } from "../../../hooks/useBuilder";
import store, { clear, setFieldState } from "../../store/formStore";
import { getCourseColor, getContrastText } from "../../../utils/courseColors";

import { momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'moment/locale/it';

import { useParams } from 'react-router';

import "react-big-calendar/lib/css/react-big-calendar.css";
import { AuthHelper } from "../../controllers/AuthHelper";
import DataTable from "../../components/Table";
import { savePdf as saveCertificato } from "./pdfs/certificato";
import { savePdf as saveVerbale } from "./pdfs/verbale_esame";
import { savePdf as saveRegistroEsame } from "./pdfs/registro_presenze_esame";
import { savePdf as saveRegistro } from "./pdfs/registro_presenze_totale";
import { savePdf as saveElenco } from "./pdfs/elenco_partecipanti";
import { savePdf as saveLettera } from "./pdfs/scheda_ammissione_corso";
import { savePdf as saveTest } from "./pdfs/scheda_test";
import { savePdf as saveTestB } from "./pdfs/scheda_test_b";
import { savePdf as saveTestC } from "./pdfs/scheda_test_c";
import { savePdf as saveLibretto } from "./pdfs/libretto";
import { savePdf as saveProgrammazione } from "./pdfs/programmazione_corso";
import { savePdf as saveLetteraLicenza } from "./pdfs/lettera_licenza";
import { savePdf as saveNullaOsta } from "./pdfs/nulla_osta";
import { savePdf as save18 } from "./pdfs/oltre_1830";
import { savePdf as saveCambio } from "./pdfs/cambio_docente";

import { CopyAll, Delete, DeleteForever, MoreHoriz, Print, SettingsPowerRounded } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ServerConfig } from "../../../connectors/Config";
import { useSelector } from 'react-redux';
import DialogContent from '@mui/material/DialogContent';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AnagraficaDiscente from "../profiles/AnagraficaDiscente";
import DocumentiDiscente from "../profiles/DocumentiDiscente";

moment.locale('it');
momentLocalizer(moment)
const style = { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4, };

const ModalDuplica = (props) => {

  const handleClose = () => props.setOpen(false);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);

  // ✅ FUNZIONE DUPLICA
  const duplicateCourse = async () => {
    try {
      if (!from || !to) {
        alert("Seleziona entrambe le date!");
        return;
      }

      const formattedFrom = from.startOf('day').format('YYYY-MM-DDT00:00:00');
      const formattedTo = to.startOf('day').format('YYYY-MM-DDT00:00:00');

      const res = await fetch(
        `${ServerConfig.AWS.Serverless.API_BASE_URL_2}/course/duplicate/${props.id}`,
        {
          method: 'PUT',
          body: JSON.stringify({ from: formattedFrom, to: formattedTo })
        }
      );

      if (!res.ok) throw new Error();

      handleClose();
      alert("Corso duplicato con successo");
    } catch {
      alert("Errore durante la duplicazione del corso");
    }
  };

  // ✅ FUNZIONE MODIFICA
  const editCourseDates = async () => {
    try {
      if (!from || !to) {
        alert("Seleziona entrambe le date!");
        return;
      }

      const formattedFrom = from.startOf('day').format('YYYY-MM-DDT00:00:00');
      const formattedTo = to.startOf('day').format('YYYY-MM-DDT00:00:00');

      const res = await fetch(
        `${ServerConfig.AWS.Serverless.API_BASE_URL_2}/career-path/course/dates/${props.id}`,
        {
          method: 'PUT',
          body: JSON.stringify({ from: formattedFrom, to: formattedTo })
        }
      );

      if (!res.ok) throw new Error();

      handleClose();
      alert("Date del corso modificate con successo");
    } catch {
      alert("Errore durante la modifica del corso");
    }
  };

  return (
    <Modal open={props.open} onClose={handleClose}>
      <Box sx={style}>
        <Typography variant="h6">
          {props.type === "edit" ? "Modifica corso" : "Duplica corso"}
        </Typography>

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
          <DatePicker
            label="Da"
            value={from}
            onChange={setFrom}
            renderInput={(props) => (
              <TextField {...props} size="small" sx={{ mt: 2, mr: 2 }} />
            )}
          />
          <DatePicker
            label="A"
            value={to}
            onChange={setTo}
            renderInput={(props) => (
              <TextField {...props} size="small" sx={{ mt: 2 }} />
            )}
          />
        </LocalizationProvider>

        <div style={{ display: 'flex', marginTop: 24, gap: 12 }}>
          <Button color="error" onClick={handleClose}>Annulla</Button>
          <Button
            onClick={() =>
              props.type === "edit"
                ? editCourseDates()
                : duplicateCourse()
            }
          >
            Invia
          </Button>
        </div>
      </Box>
    </Modal>
  );
};


export function SimpleDialog(props) {
  const { onClose, selectedValue, open, params } = props;
  const handleClose = () => { onClose(selectedValue); };

  const handleListItemClick = async(value) => {  
  const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/school/documents/rev/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify({
        document: value
      })
    })
    if(res.status === 200){ alert("Notifica inviata con successo."); onClose(value); }
  };

  return (
    <Dialog onClose={handleClose} open={open}> <DialogTitle>Notifica di revisione documentazione</DialogTitle> <List sx={{ pt: 0 }}> {props.files?.map((file) => ( <ListItem disableGutters key={file.id}> <ListItemButton onClick={() => handleListItemClick(file.name)}> <ListItemText primary={file.name} /> </ListItemButton> </ListItem> ))} </List> </Dialog>
  );
}
export function SimpleDialogAnswerRequests(props) {
  const { onClose, selectedValue, open, id, user} = props;
  const [text, setText] = useState('');
  const handleClose = () => { onClose(selectedValue); };
  const sendAnswer = async() => {
  const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/request/answer`, {
      method: 'POST',
      body: JSON.stringify({
        user,
        text,
        id
      })
    })
    if(res.ok){ alert("Risposta inviata con successo"); return onClose(); }
  }
  return (
      <Dialog onClose={handleClose} open={open} style={{padding: 24}}> <div style={{padding: 24, background: '#fff', display: 'flex', flexDirection: 'column'}}> <DialogTitle>Rispondi alla richiesta</DialogTitle> <TextField multiline maxRows={5} rows={5} onChange={(e) => setText(e.target.value)} value={text}></TextField> <Button onClick={sendAnswer}>Invia risposta</Button> </div> </Dialog>
    
  );
}
function SimpleDialogDates(props) {
  const { onClose, selectedValue, open, params, partecipant } = props;

  const [dates, setDates] = useState([]);

  const getDates = async () => {
  try {
    const user = await AuthHelper.getUserFromIdToken();
    const urlParams = new URLSearchParams(window.location.search);

    const courseId = urlParams.get('id');
    const start = urlParams.get('start');

    // Blocca la chiamata se i parametri non esistono
    if (!courseId || !start) {
      console.log('Parametri mancanti, skipping request');
      return;
    }

    const res = await fetch(
      `${ServerConfig.AWS.Serverless.API_BASE_URL_1}/school/courses/dates/${courseId}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          school: user.Username,
          from: moment(start).format('YYYY-MM-DD'),
        }),
      }
    );

    if (!res.ok) {
      console.error('Errore fetch getDates:', res.status, res.statusText);
      return;
    }

    const json = await res.json();
    console.log('dates', json);
    setDates([...json]);
  } 
  catch (err) {
    console.error('Errore fetch getDates:', err);
  }
};



  useEffect(() => {
    getDates();
  }, [])
  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = async (value) => {

    // Controllo dei parametri obbligatori
    if (!partecipant || !params?.id || !value?.id) {
      console.log('Parametri mancanti, skipping request');
      return;
    }

    try {
      const res = await fetch(
        `${ServerConfig.AWS.Serverless.API_BASE_URL_1}/school/courses/dates/move/${partecipant}`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            school: value.user,
            course: params.id,
            newCourse: value.id,
          }),
        }
      );

      if (res.ok) {
        alert('Spostamento avvenuto con successo.');
        onClose(value);
      } else {
        console.error('Errore fetch handleListItemClick:', res.status, res.statusText);
      }
    } 
    catch (err) {
      console.error('Errore fetch handleListItemClick:', err);
    }
};


  return (
    <Dialog onClose={handleClose} open={open}> <DialogTitle>Sposta data prenotazione</DialogTitle> <List sx={{ pt: 0 }}> {dates.map((date) => ( <ListItem disableGutters key={date.id}> <ListItemButton onClick={() => handleListItemClick(date)}> <ListItemText primary={`${date['nome corso']}: ${moment(date.from).format('DD/MM/YYYY')} - ${moment(date.to).format('DD/MM/YYYY')}`} /> </ListItemButton> </ListItem> ))} </List> </Dialog>
  );
}
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other} > {value === index && ( <Box sx={{ p: 3 }}> <Typography>{children}</Typography> </Box> )} </div>
    );
  }

  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const AntTab = styled((props) => <Tab {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
      minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    color: '#888',
    fontFamily: [ '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"', ].join(','),
    '&:hover': { color: '#40a9ff', opacity: 1, },
    '&.Mui-selected': { fontWeight: theme.typography.fontWeightMedium, },
    '&.Mui-focusVisible': { backgroundColor: '#d1eaff', },
  }));



  
const CourseDetail = () => {

    const [lessons, setLessons] = useState([]);
    const [loading, setLoading] = useState(false);
    const { pushMobileOpen, } = useDashboardDrawer();   
    const {builder} = useBuilder();
    const [value, setValue] = useState(0);
    const params = useParams();
    const reload = useSelector(state => state.reload);
    const [title, setTitle] = useState("");
    const [course, setCourse] = useState({});
    const [autorita, setAutorita] = useState("");
    const [dataEsame, setDataEsame] = useState("");
    const [oraEsame, setOraEsame] = useState("");
    const [fineEsame, setFineEsame] = useState("");
    const [sedeEsame, setSedeEsame] = useState("");
    const [aule, setAule] = useState([]);
    const [menuRowId, setMenuRowId] = useState(null);
    // Dialog "Conformità Decreto" per discente (Decreto D.Dir. 1986/2024)
    const [decretoDialog, setDecretoDialog] = useState({ open: false, profileId: null, nome: "" });
    const [decretoTab, setDecretoTab] = useState(0);
    const openDecreto = (row) => {
      setDecretoTab(0);
      setDecretoDialog({
        open: true,
        profileId: row.id,
        nome: `${row.first_name || ""} ${row.last_name || ""}`.trim(),
      });
    };
    const closeDecreto = () => setDecretoDialog({ open: false, profileId: null, nome: "" });

    // ✅ valore sicuro per la Select MUI
   const safeSedeEsame = Array.isArray(aule) && aule.some(a => a.id === sedeEsame) ? sedeEsame : "";
   const handleChange = (event, newValue) => { setValue(newValue); localStorage.setItem("course_tab", newValue);};

    // const [selectedValue, setSelectedValue] = React.useState();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogAnswerOpen, setDialogAnswerOpen] = useState(false);
    const [dialogDatesOpen, setDialogDatesOpen] = useState(false);

    const handleClickDatesOpen = () => { setDialogDatesOpen(true); };
    const handleCloseDatesDialog = (value) => { setDialogDatesOpen(false); getPartecipants(); };
    const handleClickOpen = () => { setDialogOpen(true); };
    const handleCloseDialog = (value) => { setDialogOpen(false); };
   // const documenti = [ 'certificate', 'verbale', 'registro', 'scheda_valutazione', 'registro_presenze', 'foglio_riepilogativo' ];
   // const elements = useSelector(state => state.elements);

   
    const columns = [
       // { field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header' },
        { field: 'teacher', headerName: 'Docente', width: 125, headerClassName: 'data-grid-header' },
        { field: 'room', headerName: 'Aula', width: 125, headerClassName: 'data-grid-header' },
        { field: 'date', headerName: 'Data', width: 125, headerClassName: 'data-grid-header', valueGetter: (params) => moment(params.row.date).format('DD/MM/YYYY')},
        { field: 'hours', headerName: 'Ore', width: 50, headerClassName: 'data-grid-header', valueGetter: (params) => Number(params.row.hours) / 10},
        { field: 'hour_ranges', headerName: 'Orari', width: 200, headerClassName: 'data-grid-header' },
        { field: 'description', headerName: 'Descrizione', width: 200, headerClassName: 'data-grid-header' },
        { field: 'pratica', headerName: 'Pratica', width: 100, headerClassName: 'data-grid-header', valueGetter: (params) => params.row.pratica === true ? 'Sì' : 'No' },
        { field: 'actions', headerName: 'Azioni', width: 100, headerClassName: 'data-grid-header', renderCell: (_params, idx) => (
          <>
          <IconButton size="small" onClick={async() => { await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/lesson/${_params.id}`, { method: 'DELETE' }); await getLessons(); }}><DeleteForever htmlColor="#DD0000" /></IconButton>
          <IconButton title="Stampa Registro" 
            onClick={async() => 
                     { const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); 
                       const payload = await res.json(); 
                       saveRegistro({lessons: lessons, ...payload, rowNumber: lessons.indexOf(lessons.filter(x => x.id === _params.row.id)[0])}); 
                      }
                    }><Print color="primary"/></IconButton></>
        )}

    ];
    const direttoriColumns = [
    //  { field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header' },
      { field: 'director', headerName: 'Direttore', width: 125, headerClassName: 'data-grid-header' },
      { field: 'actions', headerName: 'Azioni', width: 225, headerClassName: 'data-grid-header', renderCell: (_params) => (
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open2 ? 'long-menu' : undefined}
            aria-expanded={open2 ? 'true' : undefined}
            aria-haspopup="true"
            onClick={_handleClick2}
          >
                <MoreHoriz></MoreHoriz>
          </IconButton>
          <Menu
            id="long-menu"
            MenuListProps={{
              'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl2}
            open={open2}
            onClose={handleClose2}
            PaperProps={{
              style: {
                width: '20ch',
              },
            }}
          >
            <MenuItem onClick={async() => {
              await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/direttori/${_params.row.id}`);
              await getDirettori()
            }}>Rimuovi Direttore</MenuItem>
          </Menu>
        </div>
      )}
  ];
    const partecipantsColumns = [
       // { field: 'unique_id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header' },
        { field: 'avatar', headerName: 'Foto', width: 125, headerClassName: 'data-grid-header', renderCell: (params) => {
          return (
          <img src={params.row.avatar} style={{width: 85, height: 85, objectFit: 'cover', borderRadius: '100%'}} />
        ) }},
        { field: 'first_name', headerName: 'Nome', width: 200, headerClassName: 'data-grid-header' },
        { field: 'last_name', headerName: 'Cognome', width: 200, headerClassName: 'data-grid-header' },
        { field: 'status', headerName: 'Stato iscrizione', width: 200, headerClassName: 'data-grid-header' },
        { field: 'bocciato', headerName: 'Stato promozione', width: 200, headerClassName: 'data-grid-header', renderCell: (params) => params.row.bocciato ? 'Bocciato' : 'Promosso'},
        {
          field: 'conformita_decreto',
          headerName: 'Conformità Decreto',
          width: 200,
          headerClassName: 'data-grid-header',
          renderCell: (params) => (
            <Button
              size="small"
              variant="outlined"
              startIcon={<VerifiedUserIcon />}
              onClick={(e) => { e.stopPropagation(); openDecreto(params.row); }}
            >
              Anagrafica / Documenti
            </Button>
          ),
        },
        {
  field: 'documents',
  headerName: 'Documentazione',
  width: 200,
  headerClassName: 'data-grid-header',
  renderCell: (params) => (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={(e) => {
          e.stopPropagation(); // 🔥 BLOCCA drawer
          _handleClick(e);
        }}
      >
        <MoreHoriz />
      </IconButton>

      <Menu
        id="long-menu"
        MenuListProps={{ 'aria-labelledby': 'long-button' }}
        anchorEl={anchorEl}
        open={open}
        onClose={(e) => {
          e?.stopPropagation?.(); // 🔥 sicurezza extra
          handleClose();
        }}
        PaperProps={{ style: { width: '20ch' } }}
      >
        {params.row.documents.map((x) => (
          <MenuItem
            key={x.name}
            onClick={(e) => {
              e.stopPropagation(); // 🔥 BLOCCA drawer

              if (!x.file) {
                alert("L'utente deve caricare il PDF");
                return;
              }

              window.open(x.file);
            }}
          >
            {x.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
},



        //inizio ultima colonna azioni ...
        {
        field: 'actions',
        headerName: 'Azioni',
        width: 225,
        headerClassName: 'data-grid-header',
        renderCell: (_params) => (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <IconButton
              aria-label="more"
              onClick={(e) => {
                // setAnchorEl2(e.currentTarget); // apre il menu
                // setMenuRowId(_params.row.unique_id); // salva l'ID della riga cliccata

                e.stopPropagation(); // 🔥 BLOCCA il click sulla riga
                _handleClick2(e, _params.row.unique_id);

              }}
            >
              <MoreHoriz />
            </IconButton>

            <Menu
              anchorEl={anchorEl2}
              open={Boolean(anchorEl2) && menuRowId === _params.row.unique_id} // solo menu della riga corretta
              onClose={handleClose2}
              PaperProps={{ style: { width: '20ch' } }}
            >
              {_params.row.status !== 'CONFERMATO' && (
                <MenuItem
                  onClick={async (e) => {
                    if (!menuRowId) return;
                    e.stopPropagation(); // 🔥
                    await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/partecipants/${menuRowId}/CONFERMATO`, { method: 'PUT' });
                    await getPartecipants();
                    handleClose2();
                  }}
                >
                  Conferma Iscrizione
                </MenuItem>
              )}

              <MenuItem onClick={async (e) => {  e.stopPropagation(); handleClickOpen();      handleClose2(); }}>Rivedi documentazione</MenuItem>
              <MenuItem onClick={async (e) => {  e.stopPropagation(); handleClickDatesOpen(); handleClose2(); }}>Sposta prenotazione</MenuItem>
              <MenuItem onClick={async (e) => {
                  if (!menuRowId) return;
                  e.stopPropagation(); // 🔥
                  await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/prenotation/${menuRowId}`, { method: 'DELETE' });
                  await getPartecipants();
                  handleClose2(); }}>
                Rimuovi partecipante
              </MenuItem>

              <MenuItem
                onClick={async (e) => {
                  if (!menuRowId) return;
                  e.stopPropagation(); // 🔥
                  await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/partecipant/${menuRowId}/bocciato`, { method: 'PUT' });
                  await getPartecipants();
                  handleClose2();
                }}
              >
                Boccia
              </MenuItem>

              <MenuItem
                onClick={async (e) => {
                  if (!menuRowId) return;
                  e.stopPropagation(); // 🔥
                  await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/partecipant/${menuRowId}/promosso`, { method: 'PUT' });
                  await getPartecipants();
                  handleClose2();
                }}
              >
                Promuovi
              </MenuItem>
            </Menu>

            <SimpleDialog      open={dialogOpen}      onClose={handleCloseDialog}      params={_params} />
            <SimpleDialogDates open={dialogDatesOpen} onClose={handleCloseDatesDialog} params={{ id: params.id }} partecipant={_params.row.id}  />
          </div>
        )
        } //fine ultima colonna azioni ...




    ]

    const teacherColumns = [
      //{field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header'},
      {field: 'teacher', headerName: 'Nome Docente', width: 125, headerClassName: 'data-grid-header'}
    ];
    const requestColumns = [
    //  {field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header'},
      {field: 'user', headerName: 'Nome', width: 125, headerClassName: 'data-grid-header', renderCell: (params) => `${partecipants.filter(x => x.id === params.row.user)[0].first_name} ${partecipants.filter(x => x.id === params.row.user)[0].last_name}`},
      {field: 'request', headerName: 'Richiesta', width: 500, headerClassName: 'data-grid-header'},
      {field: 'actions', headerName: 'Azioni', width: 225, headerClassName: 'data-grid-header', renderCell: (_params) => (
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <IconButton aria-label="more" id="long-button" aria-controls={open2 ? 'long-menu' : undefined} aria-expanded={open2 ? 'true' : undefined} aria-haspopup="true" onClick={_handleClick2} > <MoreHoriz></MoreHoriz> </IconButton>
          <Menu id="long-menu" MenuListProps={{ 'aria-labelledby': 'long-button', }} anchorEl={anchorEl2} open={open2} onClose={handleClose2} PaperProps={{ style: { width: '20ch', }, }} >
            <MenuItem onClick={async() => { setDialogAnswerOpen(true) }}>Rispondi</MenuItem>
          </Menu>
          <SimpleDialogAnswerRequests open={dialogAnswerOpen} id={_params.row.id} user={_params.row.user} onClose={() => setDialogAnswerOpen(false)} />
        
     
        </div>
      )}
    ];
    const [partecipants, setPartecipants] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const open = Boolean(anchorEl);
    const open2 = Boolean(anchorEl2);
    const _handleClick2 = (event, rowId) => { setAnchorEl2(event.currentTarget);setMenuRowId(rowId);};
    const _handleClick = (event) => { setAnchorEl(event.currentTarget); };
    const handleClose2 = () => { setAnchorEl2(null); };
    const handleClose = () => { setAnchorEl(null); };

    
    const getLessons = async () => {
      // Blocca la chiamata se params.id non esiste
      if (!params?.id) {
        console.log('params.id undefined, skipping request');
        return;
      }

      setLoading(true);

      try {
        const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/lessons/${params.id}`);
        const data = await res.json();
        setLessons([...data]);
      } 
      catch (err) {
        console.error('Errore fetch getLessons:', err);
      } 
      finally {
        setLoading(false);
      }
    };


   const getPartecipants = async () => {
    // Controllo parametro
    if (!params?.id) {
      console.log('params.id undefined, skipping request');
      setLoading(false); // assicurati che loading venga spento
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/partecipants/${params.id}`);
      const data = await res.json();
      setPartecipants([...data]);
    } 
    catch (err) {
      console.error('Errore fetch getPartecipants:', err);
    } 
    finally {
      setLoading(false);
    }
  };



    const [richiesteIscritti, setRichiesteIscritti] = useState([]);

    const getCourse = async () => {
  // Controllo parametro
  if (!params?.id) {
    console.log('params.id undefined, skipping request');
    return;
  }

  try {
    // Prima fetch
    const courseRes = await fetch(
      `${ServerConfig.AWS.Serverless.API_BASE_URL_1}/courses/detail/${params.id}`
    );
    const course = await courseRes.json();

    if (!course?.course || course.course.length === 0 || !course.course[0]?.id) {
      console.warn('Nessun corso valido trovato per params.id:', params.id);
      return;
    }

    // Aggiornamento stato
    setCourse({
      ...course,
      teachers: course.teachers.map(x => ({
        teacher: x.teacher,
        id: Math.floor(Math.random() * 10),
      })),
    });

   const firstCourse = course.course[0];

    const safeSet = (setter, value) => {
      if (value !== undefined) setter(value);
    };

    safeSet(setAutorita,  firstCourse?.autorita_marittima);
    safeSet(setDataEsame, firstCourse?.data_esame);
    safeSet(setOraEsame,  firstCourse?.ora_esame);
    safeSet(setSedeEsame, firstCourse?.aula_esame);



    // Controllo che l'id del corso sia valorizzato prima della seconda fetch
    const courseId = course.course[0].id;
    if (courseId) {
      // Seconda fetch
      const requestInfoRes = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/course/info/list`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          courses: [`'${courseId}'`],
        }),
      });

      if (!requestInfoRes.ok) {
        console.error('Errore fetch course/info/list:', requestInfoRes.status, requestInfoRes.statusText);
      } else {
        const requestInfoData = await requestInfoRes.json();
        setRichiesteIscritti([...(requestInfoData?.payload?.[0] || [])]);
      }
    } else {
      console.log('courseId non valorizzato, salto fetch /course/info/list');
    }
  } catch (err) {
    console.error('Errore fetch getCourse:', err);
  }
};



    const [directors, setDirectors] = useState([]);

    const getDirettori = async () => {
      setLoading(true);

      // Controllo se params.id è valido
      if (!params?.id) {
        console.log('params.id undefined, skipping request');
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(
          `${ServerConfig.AWS.Serverless.API_BASE_URL_1}/lessons/direttori/${params.id}`
        );
        const data = await res.json();
        setDirectors([...data]);
      } catch (err) {
        console.error('Errore fetch direttori:', err);
      } finally {
        setLoading(false);
      }
  };


   
    
    const getAule = async () => {
      const user = await AuthHelper.getUserFromIdToken();
      const urlParams = new URLSearchParams(window.location.search);
      const course = urlParams.get('id'); // prendi il parametro

      // blocca la chiamata se course è undefined/null/empty
      if (!course) {
        console.log('Course undefined, skipping request');
        return;
      }

      try {
        const res = await fetch(
          `${ServerConfig.AWS.Serverless.API_BASE_URL_1}/aule/${user.Username}?course=${course}`
        );
        const data = await res.json();
        setAule([...data]);
      } catch (err) {
        console.error('Errore fetch aule:', err);
      }
    };


    useEffect(() => {
       getPartecipants();
    }, [reload]);


    useEffect(() => {

      // ✅ RIPRISTINO TAB
      const savedTab = localStorage.getItem("course_tab");
      if (savedTab !== null) {
        setValue(Number(savedTab));
      }

      const url = window.location.href;
      if (url.includes('#richieste_iscritti')) {
        setValue(5);
        localStorage.setItem("course_tab", 5);
      }

      getLessons();
      getPartecipants();
      getCourse();
      getDirettori();
      getAule();
      store.dispatch(clear());

      const urlParams = new URLSearchParams(window.location.search);
      setTitle(
        `Corso ${urlParams.get("nome_corso")} | 
          ${moment(urlParams.get('start')).format('DD/MM/YYYY')} - 
          ${moment(urlParams.get('end')).format('DD/MM/YYYY')}`
      );

      builder('lessons.add');

}, []);

  
    const handleCreateLezione = (data, name = null) => {
        store.dispatch(clear())
        builder('lessons.add');
        if(data.row){
           
            Object.keys(data.row).forEach((key) => {
                console.log(key)
                store.dispatch(setFieldState({name: key, value: data.row[key]}));
                if(key === 'date'){
                  store.dispatch(setFieldState({name: key, value: moment(data.row[key]).format('DD/MM/YYYY')}));
                }
                if(key === 'hour_ranges'){
                  store.dispatch(setFieldState({name: 'hour_ranges_from', value: data.row[key].split('-')[0]}));
                  store.dispatch(setFieldState({name: 'hour_ranges_to', value: data.row[key].split('-')[1]}));
                }
            });
        }
        const urlParams = new URLSearchParams(window.location.search);
        const course = urlParams.get('id');
        store.dispatch(setFieldState({name : 'course', value: course}))
        store.dispatch(setFieldState({
          name: 'school_course',
          value: params.id
        }))
        pushMobileOpen(true, 500, name ? name : "Modifica Lezione", data.row);

    }

const handleCreatePartecipante = (data, name = null) => {
      store.dispatch(clear())
      builder('partecipants.add');
      if(data.row){
          Object.keys(data.row).forEach((key) => {
              store.dispatch(setFieldState({name: key, value: data.row[key]}));
          });
      }
      const urlParams = new URLSearchParams(window.location.search);
      const course = urlParams.get('id');
      console.log('COURSE', course)
      store.dispatch(setFieldState({name : 'course', value: course}))
      store.dispatch(setFieldState({
        name: 'course_id',
        value: params.id
      }))

  
    pushMobileOpen(true, 500, name ? name : "Modifica Partecipante", data.row);
  }





  const handleCreateDocente = (data, name = null) => {
        store.dispatch(clear())
        builder('lessons.add');
        if(data.row){
           
            Object.keys(data.row).forEach((key) => {
                console.log(key)
                store.dispatch(setFieldState({name: key, value: data.row[key]}));
                if(key === 'date'){
                  store.dispatch(setFieldState({name: key, value: moment(data.row[key]).format('DD/MM/YYYY')}));
                }
                if(key === 'hour_ranges'){
                  store.dispatch(setFieldState({name: 'hour_ranges_from', value: data.row[key].split('-')[0]}));
                  store.dispatch(setFieldState({name: 'hour_ranges_to', value: data.row[key].split('-')[1]}));
                }
            });
        }
        const urlParams = new URLSearchParams(window.location.search);
        const course = urlParams.get('id');
        store.dispatch(setFieldState({name : 'course', value: course}))
        store.dispatch(setFieldState({
          name: 'school_course',
          value: params.id
        }))
        pushMobileOpen(true, 500, name ? name : "Modifica Docente", data.row);

    }
   
    const handleCreateDirettore = (data, name = null) => {
      store.dispatch(clear())
      builder('direttori.assign');
      if(data.row){
          Object.keys(data.row).forEach((key) => {
              store.dispatch(setFieldState({name: key, value: data.row[key]}));
          });
      }
      const urlParams = new URLSearchParams(window.location.search);
      const course = urlParams.get('id');
      store.dispatch(setFieldState({name : 'course', value: course}))
      store.dispatch(setFieldState({
        name: 'course_id',
        value: params.id
      }))


    pushMobileOpen(true, 500, name ? name : "Modifica Direttore", data.row);
    }

    const [loadingDelete, setLoadingDelete] = useState(false);

    const _delete = async() => { 
       try { 
         setLoadingDelete(true); 
         await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/courses/${params.id}`, 
          { method: 'DELETE' }); 
          window.location.href="/dashboard/corsi"; 
       }
       catch(ex) { 
        alert('Errore nel cancellare il corso'); 
      } 
    }

    const [selectedRow, setSelectedRows] = useState("")
    const options = { onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => { setSelectedRows(rowsSelected); console.log('ciao'); }, selectableRows: 'single', };
   
    const setSegretario = async (target) => {

      // Controllo se params.id è valido
      if (!params?.id) {
        console.log('params.id undefined, skipping request');
        return;
      }

      setLoadingDelete(true);

      try {
        const res = await fetch(
          `${ServerConfig.AWS.Serverless.API_BASE_URL_2}/segretario/${params.id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ teacher: selectedRow })
          }
        );

        if (!res.ok) {
          console.error('Errore nella chiamata setSegretario:', res.status, res.statusText);
        }
      } 
      catch (err) {
        console.error('Errore fetch setSegretario:', err);
      } finally {
        setLoadingDelete(false);
      }

      alert("Salvataggio avvenuto con successo");
} ;

   
    const [openModal, setOpenModal] = useState(false);
    const [modalType, setModalType] = useState("duplicate"); // ✅ NUOVO
    return (<Container sx={{paddingLeft: 24, paddingRight: 24, minWidth: '100vw', marginTop: '3rem'}}>
  
<ModalDuplica
  open={openModal}
  setOpen={setOpenModal}
  id={params.id}
  type={modalType}
/>



    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      {(() => {
        const _nomeCorso = new URLSearchParams(window.location.search).get('nome_corso') || '';
        const _bg = getCourseColor(_nomeCorso);
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, textAlign: 'left' }}>
            {/* Barra colorata identificativa della tipologia di corso */}
            <span style={{ display: 'inline-block', width: 10, alignSelf: 'stretch', minHeight: 40, borderRadius: 6, backgroundColor: _bg }} />
            <h1 style={{ textAlign: 'left', margin: 0 }}>{title}</h1>
            {_nomeCorso && (
              <span style={{ backgroundColor: _bg, color: getContrastText(_bg), padding: '4px 12px', borderRadius: 16, fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap' }}>
                {_nomeCorso}
              </span>
            )}
          </div>
        );
      })()}

      <div style={{width: '100%', display: 'flex', justifyContent: 'start', gap: 24, marginBottom: 24}}>
        <LoadingButton loading={loadingDelete} onClick={_delete} sx={{backgroundColor: '#B22222', color: '#fff', fontWeight: 'bold', paddingX: 4, paddingY: 1, borderRadius: 66, fontSize: 12}}> <Delete /> Elimina corso </LoadingButton>
        <LoadingButton onClick={() => { setModalType("duplicate"); setOpenModal(true); }} sx={{backgroundColor: 'rgba(4,14,99,1)',color: '#fff',fontWeight: 'bold',paddingX: 4,paddingY: 1,borderRadius: 66,fontSize: 12}}><CopyAll /> Duplica corso</LoadingButton>
        <LoadingButton onClick={() => { setModalType("edit");setOpenModal(true);}} sx={{backgroundColor: '#72d219ff',color: '#fff',fontWeight: 'bold',paddingX: 4,paddingY: 1,borderRadius: 66,fontSize: 12}}><SettingsPowerRounded /> Modifica corso</LoadingButton>
      </div>
        
      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <AntTab label="Lista lezioni" {...a11yProps(0)} />
          <AntTab label="Lista partecipanti" {...a11yProps(1)} />
          <AntTab label="Docenti corso" {...a11yProps(2)} />
          <AntTab label="Direttore corso" {...a11yProps(3)} />
          <AntTab label="Documenti corso" {...a11yProps(4)} />
          <AntTab label="Richieste iscritti" {...a11yProps(5)} />
      </Tabs>
    </Box>
     
    
      <CustomTabPanel value={value} index={0}>
        {loading && <ListSkeleton />}
        {!loading && <DataTable 
                    data={lessons || [] } 
                    columns={columns} 
                    handleClick={handleCreateLezione} 
                    actions={[
            {type: 'select', name: 'Azioni'}
        ]}/>}
        {!loading && <div style={{height: 700}}></div>}
        <FloatingActionButtons onClick={() => handleCreateLezione([], "Crea Lezione")}/>
      </CustomTabPanel>

     
    <CustomTabPanel value={value} index={1}>
        {loading && <ListSkeleton />}
        {!loading && <DataTable  rowHeight={95} 
                     data={partecipants || [] }  
                     //handleClick={() => {}}  
                     handleClick={handleCreatePartecipante}
                     columns={partecipantsColumns} 
                     actions={[{type: 'select', name: 'Azioni'}]}/>
        }
        {!loading && <div style={{height: 700}}></div>}
        <FloatingActionButtons onClick={() => handleCreatePartecipante([], "Crea Partecipante")}/>
    </CustomTabPanel>
     
    <CustomTabPanel value={value} index={2}>
       <LoadingButton loading={loadingDelete} disabled={selectedRow === ""} onClick={setSegretario} sx={{backgroundColor: '#222db2', color: '#fff', fontWeight: 'bold', paddingX: 4, paddingY: 1, borderRadius: 66, fontSize: 12, display: 'flex', mb: 5}}> Rendi segretario </LoadingButton>
        {loading && <ListSkeleton />}
        {!loading && <DataTable onSelectionChange={(e) => { setSelectedRows(course?.teachers.filter(x => x.id === e[0])[0].teacher)}} options={options} rowHeight={95} data={course?.teachers || [] } columns={teacherColumns} handleClick={handleCreateDocente} actions={[{type: 'select', name: 'Azioni'}]}/>}
        {!loading && <div style={{height: 700}}></div>} <FloatingActionButtons onClick={() => handleCreateDocente([], "Crea Docente")}/>
    </CustomTabPanel>
     
    <CustomTabPanel value={value} index={3}> 
        <FloatingActionButtons onClick={() => handleCreateDirettore([], "Crea Direttore")}/> 
          {loading && <ListSkeleton />} 
          {!loading && <DataTable rowHeight={95} 
                        data={directors || [] }  
                       // handleClick={() => {}}   
                        handleClick={handleCreateDirettore}
                        columns={direttoriColumns} 
                        actions={[ {type: 'select', name: 'Azioni'} ]}/>} 
    </CustomTabPanel>

    <CustomTabPanel value={value} index={4}>
        <div style={{display: 'flex', width: 800}}>
        <TextField size="small" fullWidth id="outlined-basic" label="Autorità marittima" variant="outlined" value={autorita} onChange={(e) => setAutorita(e.target.value)}/>
        <TextField size="small" fullWidth id="outlined-basic" label="Data esame" variant="outlined" value={dataEsame} onChange={(e) => setDataEsame(e.target.value)}/>
        <TextField size="small" fullWidth id="outlined-basic" label="Ora esame" variant="outlined" value={oraEsame} onChange={(e) => setOraEsame(e.target.value)}/>
        <TextField size="small" fullWidth id="outlined-basic" label="Fine Ora esame" variant="outlined" value={fineEsame} onChange={(e) => setFineEsame(e.target.value)}/>
        <FormControl size="small" fullWidth>
          <InputLabel id="demo-simple-select-label">Sede esame</InputLabel>
        
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={safeSedeEsame}
          size="small"
          label="Sede Esame"
          onChange={(e) => setSedeEsame(e.target.value)}
                  >
          {Array.isArray(aule) && aule.map(aula => (
            <MenuItem key={aula.id} value={aula.id}>
              {aula.name}
            </MenuItem>
          ))}
          </Select>

        
        </FormControl>
        
        <Button onClick=
            {async () => { await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/lessons/autorita/${params.id}`, 
             { method: 'PUT', 
             body: JSON.stringify({text: autorita || "", data_esame: dataEsame, ora_esame: oraEsame, fine_esame: fineEsame, sede: sedeEsame}) }); alert('Salvataggio effettuato con successo'); }}>Salva</Button>
        </div>

        <h2 style={{textAlign: 'left'}}>Lista documenti corso</h2>
        
        <ul>
          {}
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveCertificato(payload); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") }}}>Attestati corso</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); const groupedByDate = lessons.reduce((acc, item) => { const { date } = item; acc[date] = acc[date] || []; acc[date].push(item); return acc; }, {}); console.log(groupedByDate); await saveRegistro({lessons: lessons, groupedByDate,  ...payload}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Registro Presenze</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveVerbale(payload); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Verbale esame</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveRegistroEsame(payload); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Registro Presenze Esame</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveElenco(payload); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Elenco partecipanti</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveLettera({...payload, number: payload.partecipant.length}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Lettera conferma sessione esami</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveTest({...payload, number: payload.partecipant.length}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Batteria Test Corso A</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveTestB({...payload, number: payload.partecipant.length}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Batteria Test Corso B</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveTestC({...payload, number: payload.partecipant.length}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Batteria Test Corso C</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); const groupedByDate = lessons.reduce((acc, item) => { const { date } = item; acc[date] = acc[date] || []; acc[date].push(item); return acc; }, {}); await saveLibretto({...payload, groupedByDate, lessons: lessons, partecipants}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Libretto personale del corsista</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveProgrammazione({...payload, lessons: lessons, partecipants}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Programmazione corso</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveLetteraLicenza({...payload, lessons: lessons, partecipants}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Lettera licenza</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveNullaOsta({...payload, lessons: lessons, partecipants}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Nulla Osta oltre 9 Ore</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await save18({...payload, lessons: lessons, partecipants}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Nulla Osta oltre 18:30</Button> </li>
              <li style={{textAlign: 'left'}}> <Button href="#" onClick={async () => { try{ const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${params.id}`); const payload = await res.json(); await saveCambio({...payload, lessons: lessons, partecipants}); }catch(ex){ alert("Il corso oppure il profilo della scuola non sono completati. Impossibile stampare il documento.") } }}>Cambio Docente</Button> </li>      
            {}
            {}
          </ul>
        
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}> {loading && <ListSkeleton />} {!loading && <DataTable rowHeight={95} data={richiesteIscritti} columns={requestColumns} actions={[ {type: 'select', name: 'Azioni'} ]}/>} </CustomTabPanel>

      {/* DIALOG CONFORMITÀ DECRETO (Anagrafica + Documenti del discente) */}
      <Dialog open={decretoDialog.open} onClose={closeDecreto} maxWidth="md" fullWidth>
        <DialogTitle>
          Conformità Decreto — {decretoDialog.nome || "Discente"}
        </DialogTitle>
        <DialogContent dividers>
          <Tabs value={decretoTab} onChange={(e, v) => setDecretoTab(v)} sx={{ mb: 2 }}>
            <Tab label="Anagrafica Decreto" />
            <Tab label="Documenti" />
          </Tabs>
          {decretoDialog.open && decretoTab === 0 && (
            <AnagraficaDiscente profileId={decretoDialog.profileId} />
          )}
          {decretoDialog.open && decretoTab === 1 && (
            <DocumentiDiscente profileId={decretoDialog.profileId} />
          )}
        </DialogContent>
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button onClick={closeDecreto}>Chiudi</Button>
        </Box>
      </Dialog>
    </Container>);
}

export default CourseDetail;